import * as React from "react";
import { useState, useEffect, useRef, useContext } from "react";
import HeaderBanner from "../sub-components/HeaderBanner.tsx";
import Footer from "../sub-components/Footer.tsx";
import { HttpContext } from "../../api-services/HttpService";
import useWindowDimensions from "../functions/UseWindowDimensions";
import tableau from "tableau-api";
import "../../css/homePageStyle.css";
import { useLocation } from "react-router-dom";
import { Spinner } from "react-bootstrap";

type Props = {
  tableauUrl: string;
  dashboardPage: boolean;
};

// One component to embed all the different tableau content in iframe
const TableauDashboardContainer = (props: Props) => {
  const location = useLocation();
  const { GET } = useContext(HttpContext);
  const [loadingIframe, setLoadingIframe] = useState(false);
  // initialize custom hook for height and width
  const { height, width } = useWindowDimensions();
  // initialize reference for tableau dashboard
  const vizContainer = useRef();
  const viz = useRef();
  // function to calculate px from vh value
  const convertVhToPx = (vh) => {
    const oneVhInPx = window.innerHeight / 100;
    return oneVhInPx * vh;
  };

  // function to calculate px from vw value
  const convertVwToPx = (vw) => {
    const oneVwInPx = window.innerWidth / 100;
    return oneVwInPx * vw;
  };

  // intitialize tableau to embed into site
  const initViz = (vizUrl) => {
    // get environment variable for hiding tabs
    let hideTabs = false;
    if (process.env.REACT_APP_SHOW_TABLEAU_TABS == "1") {
      hideTabs = true;
    }
    // configure options
    const options = {
      // hide navigation tabs
      hideTabs: hideTabs,
      // hide bottom toolbar
      hideToolbar: props.tableauUrl ? true : false,
      // set height and width
      height: props.tableauUrl
        ? (convertVhToPx(85) - 70).toString() + "px"
        : (convertVhToPx(93) - 70).toString() + "px",
      width: props.tableauUrl
        ? "100%"
        : (convertVwToPx(100) - 80).toString() + "px",
    };
    // start viz
    viz.current = new window.tableau.Viz(vizContainer.current, vizUrl, options);
  };

  // get tableau trusted ticket to embed tableau dashboard
  const getTicket = () => {
    return new Promise((resolve, reject) => {
      GET("/tableau/ticket", {
        dashboard: props.tableauUrl
          ? props.tableauUrl
          : window.location.pathname?.slice(1),
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  // useEffect for initial render
  useEffect(() => {
    // get trusted ticket url and initialize viz
    getTicket()
      .then((res) => {
        // initialize tableau viz
        initViz(res["data"]);
        setLoadingIframe(true);
      })
      .catch((err) => {
        console.log(err);
      });

    // function to run on unrender
    return () => {
      // on unrender remove viz from div so that there is no error when the page is navigated to again
      let tempViz = window.tableau.VizManager.getVizs()[0];
      if (tempViz) {
        tempViz.dispose();
      }
    };
  }, [props.tableauUrl, location.pathname]);

  return (
    <>
      {!props.tableauUrl && (
        <div className="summary-page">
          <HeaderBanner />
          {!loadingIframe ? (
            <div className="loader-class">
              Loading content...Please wait...
              <Spinner animation="border" />
            </div>
          ) : null}
          <div ref={vizContainer} style={{ marginLeft: "38px" }}></div>
          <Footer cssClassName="footer-main-comp"/>
        </div>
      )}

      {props.tableauUrl && (
        <div ref={vizContainer} style={{ display: "block" }}>
          {!loadingIframe ? (
            <h6 className="loader-class">
              Loading content...Please wait...
              <Spinner animation="border" />
            </h6>
          ) : null}
        </div>
      )}
    </>
  );
};

export default TableauDashboardContainer;
